const healthTeamInformationSchema = {
  teamName: {
    displayName: 'Nome da equipe de saúde',
    notAvailable: 'Nome da equipe de saúde não informado',
  },
  healthTeamType: {
    displayName: 'Tipo da equipe de saúde',
    type: 'string',
    notAvailable: 'Tipo da equipe de saúde não informado',
    },
    healthUnitCnes: {
      displayName: 'CNES da unidade de saúde',
      notAvailable: 'CNES da unidade de saúde não informado',
      canCopy: false,
    },
    ine: {
    displayName: 'INE da equipe de saúde',
    notAvailable: 'INE da equipe de saúde não informado',
    canCopy: false,
  },
}

export default healthTeamInformationSchema
